"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _themeContext = _interopRequireDefault(require("../context/theme-context"));
var ThemeConsumer = function ThemeConsumer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_themeContext["default"].Consumer, null, children);
};
var _default = exports["default"] = ThemeConsumer;